export default {
    address: [
        'user-input',
        'map',
        'highway',
        'underground',
    ],
    'about-object': [
        'common/cadastral-number',
        'area-land',
        'cottage-village-name',
        'suburban-building-status-land',
        'has-electricity',
        'has-gas',
        'has-drainage',
        'has-water',
    ],
    'price-and-deal-terms': [
        'price-sale',
        'agent-bonus'
    ],
};
